import * as React from 'react';
import { Divider } from '@mui/material';

import { CustomDialog } from 'components/Dialogs/CustomDialog';

import { IUserProfile, UserProfileForm } from '../UserProfileForm';
import styles from './styles.module.scss';

type InputProps = {
  user: IUserProfile;
  open: boolean;
  setOpen: (open: boolean) => void;
  onSubmit: (user: IUserProfile, avatar?: File | Blob) => void;
};

export const UserProfileDialog = ({
  user,
  open = false,
  setOpen,
  onSubmit,
}: InputProps) => {
  const handleSubmit = (user: IUserProfile, avatar?: File | Blob) => {
    onSubmit(user, avatar);
  };

  return (
    <CustomDialog open={open} setOpen={setOpen} title="Your Profile">
      <div className={styles.root}>
        <Divider />
        <UserProfileForm user={user} onSubmit={handleSubmit} />
      </div>
    </CustomDialog>
  );
};
